import type { ArcGisClassBreaksRendererJson } from '../map/buildDefectRulesRenderer';
import { POTHOLE_RAG_BANDS } from './potholeBands';

export function buildPotholeRenderer(
  outlineWidth: number = 1,
): ArcGisClassBreaksRendererJson {
  const width = Math.max(0.5, outlineWidth);

  return {
    type: 'class-breaks',
    field: 'aveDepth',
    defaultSymbol: {
      type: 'simple-fill',
      color: `${POTHOLE_RAG_BANDS[0].color}CC`,
      style: 'solid',
      outline: {
        color: POTHOLE_RAG_BANDS[0].color,
        width,
      },
    },
    classBreakInfos: POTHOLE_RAG_BANDS.map((band) => ({
      minValue: band.min,
      maxValue: band.max,
      symbol: {
        type: 'simple-fill',
        color: `${band.color}CC`,
        style: 'solid',
        outline: {
          color: band.color,
          width,
        },
      },
    })),
  };
}
